import cn from "classnames";
import List from "components/bids/list";
import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import InlineBtn from "components/shared/inlineBtn";
import { tableContainer } from "helpers/redux";
import React from "react";
import { withRouter } from "react-router-dom";

class SharedBids extends BookIndex {
    state = {
        items: [],
    };

    renderActions = () => {
        const { mergeParams } = this.props;
        const actions = [{ value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} }];
        return actions.map((item) => <InlineBtn key={item.cname} {...item} />);
    };

    render() {
        const { nofilter, listRoute } = this.props;
        const cname = cn("page-book__list book-list list", { "book-list--nofilter": !!nofilter });
        return (
            <Transition dir="full" {...listRoute}>
                <div className={cname}>
                    {this.renderHead()}
                    <div className="container-fluid my-2">{this.renderActions()}</div>
                    <List {...this.props} checkedItems={this.state.items} toggleItem={this.toggleItem} />
                </div>
            </Transition>
        );
    }
}

export default withRouter(tableContainer(SharedBids, "sharedbids"));
